import { ADD_SESSION_ITEMS } from '@instructure/quiz-common';
export var addSessionItems = function addSessionItems(sessionItems) {
  return {
    type: ADD_SESSION_ITEMS,
    payload: sessionItems
  };
};